import { useTheme } from "../../../theme/ThemeProvider";
import { ITheme } from "../../../theme/ITheme";
import { ISectionStyles } from "../../styles";

export const useSectionStyles = (theme?: ITheme): ISectionStyles => {
    if (theme === undefined) {
        theme = useTheme();
    }

    return {
        body: {

        },
        container: {

        },
        header: {

        },
        headerTitle: {
            color: theme.palette.text.main,
            fontSize: theme.font.sizes.lg,
            fontWeight: theme.font.weights.regular
        },
    }
}